/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


/**
 * @deprecated Use UtrvStatus
 */
export const ActionList = {
  CREATED: 'created',
  VERIFIED: 'verified',
  UPDATED: 'updated',
  REJECTED: 'rejected',
};

export const NotApplicableTypes = {
  na: 'not_applicable',
  nr: 'not_reported',
}

export enum UtrvStatus {
  Created = 'created',
  Verified = 'verified',
  Updated = 'updated',
  Rejected = 'rejected',
}

export enum UtrvType {
  Actual = 'actual',
  Baseline = 'baseline',
  Target = 'target',
}

export function getTypeName(utrvType: UtrvType) {
  switch (utrvType) {
    case UtrvType.Actual: return 'Value';
    case UtrvType.Baseline: return 'Baseline';
    case UtrvType.Target: return 'Target';
  }
}

export const StatusReadableText = {
  [UtrvStatus.Created]: 'unanswered',
  [UtrvStatus.Verified]: 'verified',
  [UtrvStatus.Updated]: 'answered',
  [UtrvStatus.Rejected]: 'rejected',
}

export enum QuestionStatuses {
  Created = 'created',
  Verified = 'verified',
  Updated = 'updated',
  Rejected = 'rejected',
  NA = 'n-a',
  NR = 'n-r',
  Public = 'public',
  Private = 'private',
  NotAssured = 'not-assured',
  SentToAssurer = 'sent-to-assurer',
  Assured = 'assured',
  Disputed = 'disputed',
  Restated = 'restated'
}

export enum TagStatus {
  NoTag = 'no-tag'
}
